<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>代理管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>代理列表</span>
        <el-button size="small" type="primary" icon="el-icon-plus" style="float:right;" @click="handleAdd()">新增代理</el-button>
      </div>

      <!-- 代理列表 -->
      <el-table size="small" :data="listData" v-loading="loading" border style="width: 100%;">
        <el-table-column align="center" prop="id" label="ID" width="60"></el-table-column>
        <el-table-column align="center" prop="username" label="用户名"></el-table-column>
        <el-table-column align="center" prop="contact" label="联系方式"></el-table-column>
        <el-table-column align="center" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status == 1 ? 'success' : 'danger'">
              {{ scope.row.status == 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="grantStartTime" label="授权开始时间"></el-table-column>
        <el-table-column align="center" prop="grantEndTime" label="授权结束时间"></el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
        <el-table-column align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="warning" @click="handleResetPwd(scope.row)">重置密码</el-button>
            <el-button size="small" :type="scope.row.status == 1 ? 'danger' : 'success'" @click="handleToggle(scope.row)">
              {{ scope.row.status == 1 ? '停用' : '启用' }}
            </el-button>
            <el-button size="small" type="info" @click="handleQuota(scope.row)">配额</el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>

    <!-- 新增/编辑代理弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="50%">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="用户名" prop="username">
          <el-input size="small" v-model="editForm.username" :disabled="editMode === 'edit'" auto-complete="off"
            placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item v-if="editMode === 'add'" label="密码" prop="password">
          <el-input size="small" v-model="editForm.password" type="password" auto-complete="off"
            placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input size="small" v-model="editForm.contact" auto-complete="off" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="授权开始时间" prop="grantStartTime">
          <el-date-picker size="small" v-model="editForm.grantStartTime" type="datetime"
            placeholder="选择授权开始时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="授权结束时间" prop="grantEndTime">
          <el-date-picker size="small" v-model="editForm.grantEndTime" type="datetime"
            placeholder="选择授权结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="editMode === 'edit'" label="状态" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码弹窗 -->
    <el-dialog title="重置密码" :visible.sync="pwdVisible" width="30%">
      <el-form label-width="100px" :model="pwdForm" :rules="pwdRules" ref="pwdForm">
        <el-form-item label="新密码" prop="newPassword">
          <el-input size="small" v-model="pwdForm.newPassword" type="password" auto-complete="off"
            placeholder="请输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="pwdVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitPwd">确定</el-button>
      </div>
    </el-dialog>

    <!-- 配额设置弹窗（总配额模式） -->
    <el-dialog :title="'配额设置 - ' + (quotaAgent.username || '')" :visible.sync="quotaVisible" width="780px">
      <el-alert type="info" :closable="false"
        :title="'当前总配额（剩余点数）：' + ovTotalQuota"></el-alert>

      <!-- 配额加减 -->
      <div style="margin:14px 0; display:flex; align-items:center;">
        <span style="margin-right:8px;">调整点数：</span>
        <el-input-number size="small" v-model="adjustAmount" :min="1" :max="9999999" :step="10"
          controls-position="right" style="width:170px;"></el-input-number>
        <el-button size="small" type="primary" style="margin-left:8px;" @click="submitAdjust('add')">增加配额</el-button>
        <el-button size="small" type="danger" style="margin-left:8px;" @click="submitAdjust('sub')">扣减配额</el-button>
      </div>

      <!-- 日卡当天开卡上限（仅日卡，其他卡种不限制） -->
      <div style="margin:10px 0; display:flex; align-items:center;">
        <span style="margin-right:8px;">日卡当天：今日已开日卡 <b>{{ ovTodayOpened }}</b> 张，上限</span>
        <el-input-number size="small" v-model="ovDailyMaxOpen" :min="0" :max="999999" :step="1"
          controls-position="right" style="width:140px;"></el-input-number>
        <span style="margin:0 8px;">张（0=不限，仅限制日卡）</span>
        <el-button size="small" type="primary" @click="submitDailyMax">保存上限</el-button>
      </div>

      <el-divider content-position="left">各卡种开卡所需点数（仅对该代理生效）</el-divider>
      <el-table size="small" :data="ovCostList" border style="width: 100%;">
        <el-table-column align="center" label="卡种">
          <template slot-scope="scope">{{ quotaName(scope.row.durationDays) }}</template>
        </el-table-column>
        <el-table-column align="center" label="所需点数" width="240">
          <template slot-scope="scope">
            <el-input-number size="mini" v-model="costMap[scope.row.durationDays]" :min="0" :max="9999999"
              :step="1" controls-position="right" style="width: 150px;"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column align="center" label="可开判断">
          <template slot-scope="scope">
            <el-tag size="mini" :type="ovTotalQuota >= (costMap[scope.row.durationDays]||0) ? 'success' : 'danger'">
              {{ ovTotalQuota >= (costMap[scope.row.durationDays]||0) ? '点数足够' : '点数不足' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="110">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="submitCost(scope.row)">保存点数</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer">
        <el-button size="small" @click="quotaVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  agentList,
  agentAdd,
  agentUpdate,
  agentResetPwd,
  agentToggleStatus,
  agentQuotaOverview,
  agentQuotaAdjust,
  agentQuotaDailyMaxSave,
  agentQuotaCostSave,
  agentDelete
} from '../../api/agentMG'
import Pagination from '../../components/Pagination'

export default {
  name: 'agent',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      listData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 新增/编辑弹窗
      editFormVisible: false,
      editMode: 'add', // add | edit
      dialogTitle: '新增代理',
      editForm: {
        id: '',
        username: '',
        password: '',
        contact: '',
        grantStartTime: '',
        grantEndTime: '',
        status: 1
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系方式', trigger: 'blur' }]
      },
      // 重置密码弹窗
      pwdVisible: false,
      pwdForm: {
        id: '',
        newPassword: ''
      },
      pwdRules: {
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      },
      // 配额设置弹窗
      quotaVisible: false,
      quotaLoading: false,
      quotaAgent: {},
      ovTotalQuota: 0,            // 总配额剩余点数
      ovDailyMaxOpen: 0,          // 当天开卡上限（0=不限）
      ovTodayOpened: 0,           // 今日已开
      ovCostList: [],             // 按代理卡种点数
      adjustAmount: 10,           // 调整点数
      // 各卡种点数本地编辑值：{ 1:n, 30:n, 180:n, 365:n }
      costMap: { 1: 5, 30: 50, 180: 200, 365: 300 }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取代理列表
    getList() {
      this.loading = true
      agentList({
        page: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize
      }).then(res => {
        this.loading = false
        if (res.code == 0) {
          this.listData = res.data.list || []
          this.pageparm.total = res.data.total || 0
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('代理列表加载失败，请稍后再试！')
      })
    },
    // 分页组件回调
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getList()
    },
    // 新增代理
    handleAdd() {
      this.editMode = 'add'
      this.dialogTitle = '新增代理'
      this.editForm = {
        id: '',
        username: '',
        password: '',
        contact: '',
        grantStartTime: '',
        grantEndTime: '',
        status: 1
      }
      this.editFormVisible = true
    },
    // 编辑代理
    handleEdit(row) {
      this.editMode = 'edit'
      this.dialogTitle = '编辑代理'
      this.editForm = {
        id: row.id,
        username: row.username,
        password: '',
        contact: row.contact,
        grantStartTime: row.grantStartTime,
        grantEndTime: row.grantEndTime,
        status: row.status
      }
      this.editFormVisible = true
    },
    // 新增/编辑保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false
        }
        let reqPromise
        if (this.editMode === 'add') {
          reqPromise = agentAdd({
            username: this.editForm.username,
            password: this.editForm.password,
            contact: this.editForm.contact,
            grantStartTime: this.editForm.grantStartTime,
            grantEndTime: this.editForm.grantEndTime
          })
        } else {
          reqPromise = agentUpdate({
            id: this.editForm.id,
            contact: this.editForm.contact,
            grantStartTime: this.editForm.grantStartTime,
            grantEndTime: this.editForm.grantEndTime,
            status: this.editForm.status
          })
        }
        reqPromise.then(res => {
          this.editFormVisible = false
          if (res.code == 0) {
            this.$message.success('保存成功！')
            this.getList()
            // 通知左侧菜单：代理有变动，刷新按代理命名的用户子列表
            if (this.$root.Bus) this.$root.Bus.$emit('agentChanged')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(() => {
          this.editFormVisible = false
          this.$message.error('保存失败，请稍后再试！')
        })
      })
    },
    // 重置密码
    handleResetPwd(row) {
      this.pwdForm = {
        id: row.id,
        newPassword: ''
      }
      this.pwdVisible = true
    },
    submitPwd() {
      this.$refs.pwdForm.validate(valid => {
        if (!valid) {
          return false
        }
        agentResetPwd({
          id: this.pwdForm.id,
          newPassword: this.pwdForm.newPassword
        }).then(res => {
          this.pwdVisible = false
          if (res.code == 0) {
            this.$message.success('密码重置成功！')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(() => {
          this.pwdVisible = false
          this.$message.error('密码重置失败，请稍后再试！')
        })
      })
    },
    // 启用/停用
    handleToggle(row) {
      const newStatus = row.status == 1 ? 0 : 1
      const tip = newStatus == 1 ? '确认启用该代理？' : '确认停用该代理？'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        agentToggleStatus({
          id: row.id,
          status: newStatus
        }).then(res => {
          if (res.code == 0) {
            this.$message.success('操作成功！')
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(() => {
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => { })
    },
    // 次数卡卡种名称
    quotaName(d) {
      return d == 1 ? '日卡(1天)'
        : d == 30 ? '月卡(30天)'
          : d == 180 ? '半年卡(180天)'
            : d == 365 ? '年卡(365天)' : (d + '天卡')
    },
    // 打开配额设置弹窗
    handleQuota(row) {
      this.quotaAgent = row
      this.quotaVisible = true
      this.loadOverview()
    },
    // 加载配额总览
    loadOverview() {
      this.quotaLoading = true
      agentQuotaOverview({ agentId: this.quotaAgent.id }).then(res => {
        this.quotaLoading = false
        if (res.code == 0) {
          const d = res.data || {}
          this.ovTotalQuota = d.totalQuota || 0
          this.ovDailyMaxOpen = d.dailyMaxOpen || 0
          this.ovTodayOpened = d.todayOpened || 0
          this.ovCostList = d.costList || []
          const cm = {}
          for (const c of this.ovCostList) {
            cm[c.durationDays] = c.cost
          }
          this.costMap = cm
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.quotaLoading = false
        this.$message.error('配额加载失败，请稍后再试！')
      })
    },
    // 配额调整（add 增加 / sub 扣减）
    submitAdjust(op) {
      if (!this.adjustAmount || this.adjustAmount < 1) {
        this.$message.warning('请输入要调整的点数')
        return
      }
      agentQuotaAdjust({
        id: this.quotaAgent.id,
        amount: this.adjustAmount,
        op: op
      }).then(res => {
        if (res.code == 0) {
          this.$message.success((op === 'sub' ? '已扣减 ' : '已增加 ') + this.adjustAmount + ' 点')
          this.loadOverview()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.$message.error('调整失败，请稍后再试！')
      })
    },
    // 保存当天开卡上限
    submitDailyMax() {
      const max = this.ovDailyMaxOpen || 0
      if (max < 0) {
        this.$message.warning('上限不能为负')
        return
      }
      agentQuotaDailyMaxSave({
        id: this.quotaAgent.id,
        dailyMaxOpen: max
      }).then(res => {
        if (res.code == 0) {
          this.$message.success('日卡当天上限已保存为 ' + (max === 0 ? '不限' : max))
          this.loadOverview()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },
    // 保存某卡种点数（按代理）
    submitCost(row) {
      const cost = this.costMap[row.durationDays]
      if (cost === undefined || cost === null || cost < 0) {
        this.$message.warning('请输入有效的点数')
        return
      }
      agentQuotaCostSave({
        agentId: this.quotaAgent.id,
        durationDays: row.durationDays,
        cost: cost
      }).then(res => {
        if (res.code == 0) {
          this.$message.success(this.quotaName(row.durationDays) + ' 点数已保存为 ' + cost)
          this.loadOverview()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },
    // 删除代理（二次确认）
    handleDelete(row) {
      this.$confirm(
        '确定删除代理「' + row.username + '」？\n将清理该代理的登录信息、配额、卡密与开卡登记；'
        + '该代理开出的终端用户账户会保留（转为无代理归属的普通用户）。此操作不可恢复！',
        '删除代理', { confirmButtonText: '确定删除', cancelButtonText: '取消', type: 'warning' }
      ).then(() => {
        agentDelete({ id: row.id }).then(res => {
          if (res.code == 0) {
            this.$message.success('代理已删除')
            this.getList()
            if (this.$root.Bus) this.$root.Bus.$emit('agentChanged')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(() => {
          this.$message.error('删除失败，请稍后再试！')
        })
      }).catch(() => { })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 10px;
}

.page-box {
  margin: 10px auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/system/agent.vue